// Гибкая шкала и «да/нет» для анкет конструктора адаптации. [Claude] 2026-11-02, Чат 3, №7

export function scaleValues(scale = {}) {
    const min = Number(scale.min ?? 1);
    const max = Number(scale.max ?? 5);
    const step = Number(scale.step ?? 1);
    if (!Number.isFinite(min) || !Number.isFinite(max) || !(step > 0) || max <= min) return [];
    const count = Math.round((max - min) / step);
    if (count > 100) return [];
    return Array.from({ length: count + 1 }, (_, i) => Number((min + i * step).toFixed(6)));
}

function optionsFor(question) {
    if (question.type === "yes_no") return [{ value: "да", label: "Да" }, { value: "нет", label: "Нет" }];
    const scale = question.scale || {};
    return scaleValues(scale).map((n) => ({ value: n, label: String(n), hint: scale.labels?.[String(n)] }));
}

export default function ChoiceButtons({ question, value, onChange, disabled, compact = false }) {
    const scale = question.scale || {};
    const options = optionsFor(question);
    const specials = question.type === "scale" ? (question.special_options || scale.special || []) : [];
    const isActive = (v) => value != null && String(value) === String(v);
    const base = compact
        ? "min-h-8 rounded-md border px-2 py-1 text-xs font-semibold transition disabled:opacity-60"
        : "min-h-11 rounded-xl border px-3 py-2 text-sm font-semibold transition disabled:opacity-60";
    const on = "border-amber-400 bg-amber-400 text-slate-950 shadow";
    const off = "border-slate-200 bg-white text-slate-700 hover:border-slate-400";
    return (
        <div className={compact ? "mt-1.5" : "mt-3"}>
            {options.length > 11 ? (
                <select
                    className="min-h-12 w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-base outline-none focus:border-amber-400 focus:ring-4 focus:ring-amber-100"
                    value={value ?? ""}
                    disabled={disabled}
                    onChange={(e) => {
                        const raw = e.target.value;
                        const match = options.find((o) => String(o.value) === raw);
                        onChange(raw === "" ? undefined : match ? match.value : raw);
                    }}
                >
                    <option value="">—</option>
                    {options.map((o) => <option key={o.value} value={o.value}>{o.hint ? `${o.label} — ${o.hint}` : o.label}</option>)}
                    {specials.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
                </select>
            ) : (
                <div className="flex flex-wrap gap-1.5" role="radiogroup">
                    {options.map((o) => (
                        <button
                            key={o.value}
                            type="button"
                            role="radio"
                            aria-checked={isActive(o.value)}
                            title={o.hint || undefined}
                            disabled={disabled}
                            onClick={() => onChange(isActive(o.value) ? undefined : o.value)}
                            className={`${base} ${question.type === "yes_no" ? (compact ? "min-w-14" : "min-w-20") : (compact ? "min-w-8" : "min-w-11")} ${isActive(o.value) ? on : off}`}
                        >
                            {o.label}
                            {o.hint ? <span className="block text-[10px] font-normal leading-3 opacity-70">{o.hint}</span> : null}
                        </button>
                    ))}
                </div>
            )}
            {question.type === "scale" && (scale.min_label || scale.max_label) ? (
                <div className="mt-1.5 flex justify-between gap-4 text-xs text-slate-500">
                    <span>{scale.min ?? ""} — {scale.min_label}</span>
                    <span className="text-right">{scale.max ?? ""} — {scale.max_label}</span>
                </div>
            ) : null}
            {options.length <= 11 && specials.length ? (
                <div className="mt-2 flex flex-wrap gap-1.5">
                    {specials.map((s) => (
                        <button
                            key={s.value}
                            type="button"
                            disabled={disabled}
                            onClick={() => onChange(isActive(s.value) ? undefined : s.value)}
                            className={`${base} ${isActive(s.value) ? on : off} font-normal`}
                        >
                            {s.label}
                        </button>
                    ))}
                </div>
            ) : null}
        </div>
    );
}
